import { useCallback } from 'react';

const apiCache = new Map();
const inFlightRequests = new Map();

export const useCachedApi = () => {
    const requestApi = useCallback((cacheKey, apiFunction) => {
        if (apiCache.has(cacheKey)) {
            return Promise.resolve(apiCache.get(cacheKey));
        }

        if (inFlightRequests.has(cacheKey)) {
            return inFlightRequests.get(cacheKey);
        }

        const requestPromise = apiFunction()
            .then((response) => {
                apiCache.set(cacheKey, response);
                inFlightRequests.delete(cacheKey);
                return response;
            })
            .catch((error) => {
                inFlightRequests.delete(cacheKey);
                throw error;
            });

        inFlightRequests.set(cacheKey, requestPromise);
        return requestPromise;
    }, []);

    const clearCache = useCallback((cacheKey) => {
        if (cacheKey) {
            apiCache.delete(cacheKey);
        } else {
            apiCache.clear();
        }
    }, []);

    return { requestApi, clearCache };
};

export default useCachedApi;
